<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Add a review manually</h1>
        </template>
        <div class="mb-4 w-full">
            <label class="font-bold">What do you want to do?</label>
            <input id="allow" type="radio" name="action" value="allow" class="hidden" v-model="action">
            <label for="allow" class="cursor-pointer">
                <div class="flex items-start p-3">
                    <span class="indicator w-4 h-4 inline-block rounded-full border border-primary flex-shrink-0 bg-primary-lighter"></span>
                    <div class="ml-2 min-w-0">
                        <p class="leading-none">Allow</p>
                    </div>
                </div>
            </label>
            <input id="deny" type="radio" name="action" value="deny" class="hidden" v-model="action">
            <label for="deny" class="cursor-pointer">
                <div class="flex items-start p-3">
                    <span class="indicator w-4 h-4 inline-block rounded-full border border-primary flex-shrink-0 bg-primary-lighter"></span>
                    <div class="ml-2 min-w-0">
                        <p class="leading-none">Block</p>
                    </div>
                </div>
            </label>
        </div>
        <div class="my-4 w-full">
            <label for="address" class="font-bold">What's the email address?</label>
            <input type="text" name="address" id="address" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="johndoe@example.com" v-model="value">
            <p class="text-destructive" v-if="errors['values.0'] && errors['values.0'].length > 0">This must be a valid email address.</p>
        </div>
        

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Adding..."
                @click.native="submit"
            >
                Add
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    data() {
        return {
            type   : 'address',
            value  : '',
            action : 'deny',
            loading: false,
            errors: {}
        }
    },
    methods: {
        submit() {
            this.errors = {};
            this.loading = true;
            axios.post('/api/intents', {
                type  : this.type,
                values: [this.value],
                action: this.action,
                spell : null,
            }).then(response => {
                this.$emit('resolve');
            }).catch(error => {
                this.errors = error.response.data.errors;
            }).then(() => {
                this.loading = false;
            })
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>